import React, { useState } from 'react'
import noop from 'lodash/noop'
import { Button, TextInputOld } from '@doseme/cohesive-ui'

import { TProps } from './types'
import { INSTALLATIONS_URL } from '../../../../constants/urls/frontend'
import { INewInstallation } from '../../../../types/installation'
import { FormPageLayout } from '../../../../components/FormPageLayout'
import { StyledForm } from '../../../../components/StyledForm'
import { TFormsValidity } from '../../types'

type TKey = 'description' | 'uri' | 'code'

const Create: React.FC<TProps> = ({ installationsLoading, createInstallation, history }) => {
  const [newInstallation, update] = useState<INewInstallation>({
    description: '',
    uri: '',
    code: ''
  })

  const [fieldsValidity, setFieldsValidity] = useState<TFormsValidity<TKey>>({
    description: {
      touched: false,
      valid: true
    },
    uri: {
      touched: false,
      valid: true
    },
    code: {
      touched: false,
      valid: true
    }
  })

  const [error, updateError] = useState('')

  const handleInput = (name: string, value: string, valid: boolean) => {
    if (valid) {
      update({ ...newInstallation, [name]: value })
    }

    setFieldsValidity({
      ...fieldsValidity,
      [name]: {
        touched: true,
        valid
      }
    })
  }

  const handleSubmit = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    updateError('')

    const { status, message } = await createInstallation({
      ...newInstallation
    })

    if (status >= 400) {
      updateError(message)
      return
    }

    history.push(INSTALLATIONS_URL)
  }

  const formValid = (['description', 'uri', 'code'] as TKey[]).every(
    (field) => fieldsValidity[field].valid && fieldsValidity[field].touched
  )

  return (
    <FormPageLayout title='Add New Installation' handleBackClick={() => history.push(INSTALLATIONS_URL)}>
      <StyledForm handleSubmit={handleSubmit}>
        {error}
        <TextInputOld
          name='code'
          type='text'
          defaultValue={newInstallation.code}
          onBlur={(value, valid) => handleInput('code', value, valid)}
          placeholder='Code'
          label='Code'
          isRequired
        />
        <br />

        <TextInputOld
          name='description'
          label='Description'
          type='text'
          defaultValue={newInstallation.description}
          onBlur={(value, valid) => handleInput('description', value, valid)}
          placeholder='Description'
          isRequired
        />
        <br />

        <TextInputOld
          name='uri'
          type='text'
          label='URI'
          defaultValue={newInstallation.uri}
          onBlur={(value, valid) => handleInput('uri', value, valid)}
          placeholder='URI'
          isRequired={true}
        />
        <br />
        <hr />

        <div className='d-flex w-100 justify-content-end'>
          <Button type='submit' variant='primary' onClick={noop} disabled={!formValid} loading={installationsLoading}>
            Create
          </Button>
        </div>
      </StyledForm>
    </FormPageLayout>
  )
}

export { Create }
